// extracted by mini-css-extract-plugin
export default {"root":"CBafYr","noText":"pUcpYW","noTextSubtitle":"ong3SS"};